// extracted by mini-css-extract-plugin
export default {"box":"styles_box__pmvx-","cards":"styles_cards__GVGmo","selectButton":"styles_selectButton__Ic0H9"};